import { render, staticRenderFns } from "./fwd.vue?vue&type=template&id=481a2871&scoped=true&"
import script from "./fwd.vue?vue&type=script&lang=js&"
export * from "./fwd.vue?vue&type=script&lang=js&"
import style0 from "./fwd.vue?vue&type=style&index=0&id=481a2871&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481a2871",
  null
  
)

export default component.exports